<main class="d-padding">
    <div class="form-group">
        <!-- <div class="icon-addon">
            <input type="text" placeholder="Search for CoPilots and Clients" class="form-control" [(ngModel)]="searchText" (ngModelChange)="searchInputChanged()" />
            <button class="btn"><i class="icon icon-search-new"></i></button>
        </div> -->
    </div>

    <h2 class="title">Trash box</h2>
    <div class="select-custom form-filter">
        <!-- <i class="icon-angle-down"></i>
        <select class="form-control" [(ngModel)]="filterClientName" (ngModelChange)="filterClientChanged()">
			<option value="" class="option-value">Filter Client</option>
			<option *ngFor="let clientName of clientNames" value="{{clientName}}">{{clientName}}</option>
        </select> -->

        <!-- <div class="form-group">
            <div (click)="searchList = !searchList">
                <input type="text" name="client_selected" [readonly]="true" [(ngModel)]="filterClientName" class="form-control" placeholder="Filter Client" />
            </div>

            <i class="icon icon-cira" (click)="filterClientName = ''; filterClientChanged()" *ngIf="filterClientName != ''"></i>
            <i class="icon icon-angle-down" (click)="searchList = !searchList" *ngIf="filterClientName == ''"></i>

            <div class="SearchDropdown border rounded" *ngIf="searchList && clientNames.length > 0">
                <ng-scrollbar class="d-scroll">
                    <ul>
                        <li class="link" *ngFor="let clientName of clientNames" (click)="filterClientName = clientName; searchList = false; filterClientChanged()">{{clientName}}</li>
                    </ul>
                </ng-scrollbar>
            </div>
        </div> -->
    </div>

    <section class="va-wrapper">
        <!-- card list -->
        <!-- <div class="card-list">
            <h3 class="topic-title">Recent</h3>
            <div class="row">
                <div class="col" *ngFor="let project of recentlyCreatedProjects">
                    <app-virtual-assistant-card [vaAgent]=project></app-virtual-assistant-card>
                </div>
            </div>
        </div> -->

        <div class="card-list" *ngFor="let sectorGroup of groupedProjects">
            <h3 class="topic-title">{{sectorGroup.sector}}</h3>
            <div class="row">
                <div class="col" *ngFor="let project of sectorGroup.projects">
                    <app-virtual-assistant-card [vaAgent]=project></app-virtual-assistant-card>
                    <!-- [isSmallCard]="true" -->
                </div>
            </div>
        </div>

 
        <div class="loading" *ngIf="loadingStatus"><p>Loading...</p></div>
        <div *ngIf="groupedProjects.length == 0 && groupedProjects.length == 0 && !loadingStatus" class="card-list no-project">
            <p>No project found</p>
        </div>

    </section>
    
</main>


